<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        文物单位信息列表
      </div>
      <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
      </div>-->
    </div>
    <div class="common-page common-body">
      <div class="flex">
        <div class="common-page common-list" v-loading="loading">
          <div class="common-page common-tool-bar">
            <div
              v-hasPermi="['monitor:wenwu:query']"
              class="btn"
              @click="showDia = true"
            >
              <i class="icon-tr-search"></i>查询
            </div>
            <router-link
              v-hasPermi="['monitor:wenwu:add']"
              class="btn ml20"
              to="/company/wenwu-add"
            >
              <i class="icon-tr-newly-added"></i>新增
            </router-link>
          </div>

          <el-table :data="list" class="">
            <el-table-column
              prop="c_name"
              label="单位名称"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="c_number"
              label="单位编号"
              align="center"
            ></el-table-column>

            <el-table-column prop="c_address" align="center" label="单位地址">
            </el-table-column>
            <el-table-column label="操作" align="center" width="160px">
              <template slot-scope="scope">
                <router-link
                  v-hasPermi="['monitor:wenwu:edit']"
                  :to="{
                    path: '/company/wenwu-add',
                    query: { id: scope.row.w_uuid },
                  }"
                >
                  <el-button size="mini" type="warning" plain>编辑</el-button>
                </router-link>
                <el-popconfirm
                  v-hasPermi="['monitor:wenwu:remove']"
                  title="确定禁用单位记录吗？"
                  class="cursor"
                  @onConfirm="del(scope.row)"
                >
                  <a slot="reference" class="red">
                    <el-button size="mini" type="danger" plain>删除</el-button>
                  </a>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="pageChange"
        :page-size="10"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog
      title="查询"
      :visible.sync="showDia"
      :close-on-click-modal="false"
    >
      <fm-generate-form
        :data="searchForm"
        :remote="remoteFuncs"
        :value="editData"
        ref="searchForm"
      ></fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small"
          >确定</el-button
        >
        <el-button @click="canclesear" size="small">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCompanyList, switchCompany } from "../../api/company";
import { getMapByid } from "../../api/common";
import unitList from "@/components/unitList";

export default {
  components: { unitList },
  data() {
    return {
      list: [],
      mapCode: {},
      params: {
        page: 1,
        c_belong_profession: "",
        area: "",
      },
      total: 0,
      showDia: false,
      searchForm: this.$getForm("ww_search"),
      editData: {},
      remoteFuncs: {},
      loading: false,
    };
  },
  created() {
    getMapByid(66).then((res) => {
      var obj = {};
      res.data.map((item, index) => {
        obj[item.mc_id] = item.mc_name;
      });
      this.mapCode = obj;
      this.getOne();
      setTimeout(() => {
        this.getList();
      }, 200);
    });
  },
  methods: {
    canclesear() {
      this.showDia = false;
      this.resetSearch();
      this.getList();
    },
    changedata(dat) {
      dat = JSON.parse(dat);
      var str = "";
      dat.map((item) => (str += item + ","));
      str = str.substring(0, str.length - 1);
      return str;
    },
    getList() {
      this.loading = true;
      this.$post(
        "/trxf/main/xf/danwei/xfdanweixinxi/baseListnewanother",
        this.params
      ).then((res) => {
        this.list = res.list;
        this.total = res.count;
        this.loading = false;
      });
    },

    getOne(val) {
      this.params.c_company_num = val;
    },
    getUnit(val) {
      this.params.c_company_num = val;
      this.getList();
    },
    del(it) {
      this.$post("checklist/seruritytabledel", { w_uuid: it.w_uuid }).then(
        (res) => {
          if (res.code < 1000) {
            this.$message({message: res.msg,type: "success", duration: 700,});
            this.getList();
          }
        }
      );
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { ...this.params, ...this.$refs.searchForm.models };
    },
  },
};
</script>

<style scoped>
</style>